import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Readed",
  "use": "icon-Readed-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-Readed\">\r\n<path d=\"M12.4,200l83-71.3h9.3L188,200H12.4L12.4,200z M200,192.1l-64.6-56L200,80V192.1L200,192.1z M95.3,0h10l91,64.6L124,126.4\r\n\tl-15.6-12H92.1l-16,12L4,65L95.3,0z M0,80l65.3,56L0,192.1V80z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol